module.exports = __webpack_public_path__ + "static/media/Piloswine_gaussian2.02ad85ce.png";